module.exports = __webpack_public_path__ + "img/customReportConfig.3168970b.svg";